import { render, staticRenderFns } from "./identity-protection.vue?vue&type=template&id=e9d54938&"
import script from "./identity-protection.vue?vue&type=script&lang=ts&"
export * from "./identity-protection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports